<template>
  <section class="AssignmentDetailsInfo">
    <ChipsColumns :items="infoChipItems" />
    <v-alert
      v-if="assignment.notes"
      type="info"
      color="blue darken-1"
      outlined
      border="top"
      class="mt-6"
    >
      {{ assignment.notes }}
    </v-alert>
  </section>
</template>

<script>
import { formatAssignmentDuration } from '@/helpers/assignments/format';

export default {
  name: 'AssignmentDetailsInfo',
  components: {
    ChipsColumns: () => import('../profiles/ChipsColumns'),
  },
  props: {
    assignment: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    infoChipItems() {
      const { assignment } = this;
      const attemptsLeft = assignment?.contentSettings.maxAttempts - assignment.reports?.length;

      const chips = [
        {
          icon: 'notes',
          title: 'Name',
          text: assignment?.name,
        },
        {
          icon: 'subject',
          title: 'Subject',
          text: assignment?.subject,
        },
        {
          icon: 'quiz',
          title: 'Type',
          text: assignment?.type,
        },
        {
          icon: 'date_range',
          title: 'Start',
          text: this.$moment(assignment?.startDate).format('MM/DD/YYYY hh:mm A'),
        },
        {
          icon: 'date_range',
          title: 'Due',
          text: this.$moment(assignment?.dueDate).format('MM/DD/YYYY hh:mm A'),
        },
        {
          icon: 'replay_circle_filled',
          title: 'Attempts',
          text: `${attemptsLeft}/${assignment?.contentSettings.maxAttempts}`,
        },
      ];

      if (assignment?.duration) {
        const duration = formatAssignmentDuration(assignment.duration, false);
        const timerChip = {
          icon: 'timer',
          title: 'Duration',
          text: duration,
        };
        chips.splice(3, 0, timerChip);
      }

      return chips;
    },
  },
};
</script>
